exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".IconMinimize_iconClose__lLQAR{cursor:pointer}.IconMinimize_iconClose__lLQAR:hover{fill:#c2c2c2}.IconMinimize_iconClose__lLQAR:active{fill:#999}", ""]);

// exports
exports.locals = {
	"iconClose": "IconMinimize_iconClose__lLQAR"
};